<template>
    <base-page>
        <!-- <titlu-pagina Titlu="Setari SMS" /> -->

        <el-row class="main-page">

            <el-col class="coloana" :span="16">
                <el-card style='margin:5px 0px 5px 0px;'>
                    <div slot="header">
                        <span>Setari SMS</span>

                        <el-button @click="save_sms" style="float: right; padding: 6px 12px; " type="success" plain
                            round size="large"> Salveaza </el-button>
                        <el-button @click="sterge_sms" style="float: right; padding: 6px 12px; margin: 0 10px;"
                            type="danger" plain round size="large"> Sterge </el-button>

                    </div>
                    <el-form label-position="top" :model="Setari_Sms" :inline="false" :rules="rules_sms" size="mini"
                        label-width="100%" ref='my-sms-form' @submit.prevent="save_sms">
                        <el-row>
                            <el-form-item label='Mesaj SMS (Generare programare)' prop="Mesaj">
                                <el-input @focus="switch_focus('mesaj')" @blur="remove_focus()"
                                    v-model="Setari_Sms.Mesaj" type="textarea"></el-input>
                                <p style="float: right; opacity: 0.5;"> {{Setari_Sms.Mesaj.length}} caractere</p>
                                <p style="float: left; opacity: 0.5;">Numar mesaje:
                                    {{Math.ceil(Setari_Sms.Mesaj.length/160)}}</p>
                            </el-form-item>
                            <el-form-item label='Mesaj SMS (Amanare)' prop="Mesaj">
                                <el-input @focus="switch_focus('mesaj1')" @blur="remove_focus()"
                                    v-model="Setari_Sms.MesajAmanare" type="textarea"></el-input>
                                <p style="float: right; opacity: 0.5;"> {{Setari_Sms.MesajAmanare.length}} caractere</p>
                                <p style="float: left; opacity: 0.5;">Numar mesaje:
                                    {{Math.ceil(Setari_Sms.MesajAmanare.length/160)}}</p>
                            </el-form-item>
                            <el-form-item label='Mesaj SMS (Anulare)' prop="Mesaj">
                                <el-input @focus="switch_focus('mesaj2')" @blur="remove_focus()"
                                    v-model="Setari_Sms.MesajAnulare" type="textarea"></el-input>
                                <p style="float: right; opacity: 0.5;"> {{Setari_Sms.MesajAnulare.length}} caractere</p>
                                <p style="float: left; opacity: 0.5;">Numar mesaje:
                                    {{Math.ceil(Setari_Sms.MesajAnulare.length/160)}}</p>
                            </el-form-item>
                            <el-form-item label='Reminder SMS (9 ore inainte)' prop="Reminder">
                                <el-input @focus="switch_focus('reminder')" @blur="remove_focus()"
                                    v-model="Setari_Sms.Reminder" type="textarea"></el-input>
                                <p style="float: right; opacity: 0.5;"> {{Setari_Sms.Reminder.length}} caractere</p>
                                <p style="float: left; opacity: 0.5;">Numar mesaje:
                                    {{Math.ceil(Setari_Sms.Reminder.length/160)}}</p>
                            </el-form-item>
                            <el-form-item label='Reminder SMS (2 ore inainte)' prop="Reminder2">
                                <el-input @focus="switch_focus('reminder2')" @blur="remove_focus()"
                                    v-model="Setari_Sms.Reminder2" type="textarea"></el-input>
                                <p style="float: right; opacity: 0.5;"> {{Setari_Sms.Reminder2.length}} caractere</p>
                                <p style="float: left; opacity: 0.5;">Numar mesaje:
                                    {{Math.ceil(Setari_Sms.Reminder2.length/160)}}</p>
                            </el-form-item>
                        </el-row>
                        <span class="commands">Comenzi rapide</span>
                        <hr />

                        <div class="commands-btn-area">
                            <el-button @click="quick_add('[Nume]')" size="small">Nume</el-button>
                            <el-button @click="quick_add('[Prenume]')" size="small">Prenume</el-button>
                            <el-button @click="quick_add('[NrAuto]')" size="small">Nr auto</el-button>
                            <el-button @click="quick_add('[Data]')" size="small">Data</el-button>
                            <el-button @click="quick_add('[Ora]')" size="small">Ora</el-button>
                            <el-button @click="quick_add('[#Programare]')" size="small">#Programare</el-button>
                            <el-button v-if="this.Setari_Sms.mode == 'reminder' || this.Setari_Sms.mode == 'reminder2'"
                                @click="quick_add('[OreRamase]')" size="small">Ore ramase</el-button>
                        </div>
                        <br />
                        <span class="commands">Testeaza mesajul prin sms</span>
                        <hr />
                        <el-form-item label="Numar de telefon">
                            <el-input placeholder="Introduceti numarul de telefon unde doriti sa faceti testul"
                                v-model="Setari_Sms.Telefon"></el-input>
                        </el-form-item>

                        <div class="butoane">
                            <el-button @click="test_sms('mesaj')" type="success" plain round size="small">Test mesaj
                            </el-button>
                            <el-button @click="test_sms('amanare')" type="success" plain round size="small">Test mesaj amanare
                            </el-button>
                            <el-button @click="test_sms('anulare')" type="success" plain round size="small">Test mesaj anulare
                            </el-button>
                            <el-button @click="test_sms('reminder')" type="success" plain round size="small">Test
                                reminder 9h</el-button>
                            <el-button @click="test_sms('reminder2')" type="success" plain round size="small">Test
                                reminder 2h</el-button>
                        </div>
                    </el-form>

                </el-card>
            </el-col>
        </el-row>



    </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";


export default {
    name: "Setari_programator",
    extends: BasePage,
    components: {
        "base-page": BasePage,
        "titlu-pagina": TitluPagina,
    },
    data() {
        return {
            Setari_Sms: {
                mode: '',
                Mesaj: '',
                MesajAmanare: '',
                MesajAnulare: '',
                Reminder: '',
                Reminder2: '',
                Telefon: '',
            },
            rules_sms: {
                Mesaj: [{ required: true, message: 'Campul este obligatoriu' }],
                Reminder: [{ required: true, message: 'Campul este obligatoriu' }],
                Reminder2: [{ required: true, message: 'Campul este obligatoriu' }],

            }

        };
    },
    methods: {
        sterge_sms: async function () {
            this.Setari_Sms.Mesaj = '';
            this.Setari_Sms.Reminder = '';
            this.Setari_Sms.Reminder2 = '';
        },

        switch_focus: function (prop) {
            // console.log('e in focus');
            switch (prop) {
                case 'mesaj': {
                    this.Setari_Sms.mode = 'mesaj';
                    break;
                };
                case 'mesaj1': {
                    this.Setari_Sms.mode = 'mesaj1';
                    break;
                };
                case 'mesaj2': {
                    this.Setari_Sms.mode = 'mesaj2';
                    break;
                };
                case 'reminder': {
                    this.Setari_Sms.mode = 'reminder';
                    break;
                }

                case 'reminder2': {
                    this.Setari_Sms.mode = 'reminder2';
                    break;
                }
            }
        },

        remove_focus: function () {
            // console.log('nu mai e in focus');
        },

        quick_add: async function (word) {
            // console.log(focus)
            switch (this.Setari_Sms.mode) {
                case 'mesaj': {
                    this.Setari_Sms.Mesaj = this.Setari_Sms.Mesaj + ` ${word}`;
                    break;
                }                
                case 'mesaj1': {
                    this.Setari_Sms.MesajAmanare = this.Setari_Sms.MesajAmanare + ` ${word}`;
                    break;
                }                
                case 'mesaj2': {
                    this.Setari_Sms.MesajAnulare = this.Setari_Sms.MesajAnulare + ` ${word}`;
                    break;
                }
                case 'reminder': {
                    this.Setari_Sms.Reminder = this.Setari_Sms.Reminder + ` ${word}`;
                    break;
                }
                case 'reminder2': {
                    this.Setari_Sms.Reminder2 = this.Setari_Sms.Reminder2 + ` ${word}`;
                    break;
                }
            }
        },

async get_info(){
      var response                          = await this.post("admin/setari/index" );
      this.Setari_Sms.Mesaj                 = response.Setari.Mesaj_sms;
      this.Setari_Sms.MesajAmanare     = response.Setari.Mesaj_amanare;
      this.Setari_Sms.MesajAnulare          = response.Setari.Mesaj_anulare;
      this.Setari_Sms.Reminder              = response.Setari.Reminder_sms;
      this.Setari_Sms.Reminder2             = response.Setari.Reminder_sms2;

    },


    test_sms: async function (mode) {
      if (this.Setari_Sms.Telefon == '' || this.Setari_Sms.Telefon.length < 0) {
        this.$notify({
          title: "Eroare",
          message: "Trebuie sa specificati un numar de telefon",
          type: "error"
        })
      } else {
          let response = await this.post('admin/setari/test_sms', {Telefon: this.Setari_Sms.Telefon, Mode: mode});
          // console.log(response);
          this.$notify({
                    title: 'Succes',
                    message: 'Mesajul de test a fost trimis cu succes!',
                    type: 'success',
                });
          

      }
    },

      
    save_sms: async function() {
      this.$refs['my-sms-form'].validate( async (valid) => {
        if (valid) {
          var save_sms_response = await this.post('admin/setari/save_sms', {Mesaj: this.Setari_Sms.Mesaj, Reminder: this.Setari_Sms.Reminder, Reminder2: this.Setari_Sms.Reminder2, Mesaj_amanare: this.Setari_Sms.MesajAmanare, Mesaj_anulare: this.Setari_Sms.MesajAnulare});
          if (save_sms_response.Raspuns) {
            this.$notify({
                    title: 'Succes',
                    message: 'Modificarile au fost salvate!',
                    type: 'success',
                });
            } else {
                this.$notify({
                    title: 'Eroare',
                    message: 'A aparut o problema - modificarile nu au fost salvate!',
                    type: 'error',
                });
          }
        }
      });
    },

    },


    mounted() {
        if (!this.$has_right('Management')) {
            this.$router.push("/no-rights");
            return;
        }
        this.base_url = settings.BASE_URL;
        this.get_info();
    },
};
</script>

<style lang="less" scoped>
.main-page {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
}

.commands {
    font-size: 14px;
    opacity: 0.3;
}

.commands-btn-area {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .el-button {
        margin: 5px 0;
        width: 40%;
        font-size: 14px;
    }
}

.top50 {
    margin-top: 20px;
}

.filtre {
    .el-input-number {
        width: 100% !important;
    }
}

.input-element {
    width: 50%;
}

@media only screen and (max-width: 600px) {
    .input-element {
        width: 80%;
    }

    .main-page {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .coloana {
            width: 95%;
        }
    }

    .el-tooltip__popper {
        width: 90%;
    }
}
</style>
